import React from "react";
import repairIco from "../../../assets/img/ico/repair.svg";
import plumbingIco from "../../../assets/img/ico/plumbing.svg";
import zincIco from "../../../assets/img/ico/zinc.svg";
import worker from "../../../assets/img/ico/worker.png";

import "./service.css";
import "./service-part2.css";

export default function Service() {
  // const services = [
  //   {
  //     name: "Plomberie",
  //     icon: plumbingIco,
  //     offset: "50%",
  //     tags: [
  //       "Rénovation",
  //       "Traitement de l’eau",
  //       "Recherche de fuites",
  //       "Curage et pompage",
  //       "Pompe à chaleur",
  //       "Dégorgement / débouchage",
  //     ],
  //     def: [
  //       "De la salle de bain à la cuisine, en passant par la <strong>rénovation complète</strong> d’un <strong>réseau de plomberie</strong>, nous prenons en charge vos projets du <strong>diagnostic à la finition</strong>. Nous collaborons avec les autres corps de métier pour un chantier maîtrisé, dans le respect des délais et des normes.",
  //       "Améliorez la qualité de votre eau grâce à des solutions adaptées : <strong>adoucisseurs, systèmes anti-calcaire, filtres spécifiques…</strong> Nous vous conseillons sur les <strong>meilleures options selon votre installation et vos besoins.</strong>",
  //       "Nous utilisons des méthodes non destructives (fluorescéine, caméra thermique, testeur d’humidité) pour localiser les fuites sans détériorer vos murs ou vos sols. Une <strong>solution rapide et économique</strong> pour éviter les dégâts majeurs.",
  //       "Pour les colonnes de chute, les réseaux collectifs ou les fosses, nous proposons des prestations de <strong>curage haute pression et de pompage</strong>, <strong>indispensables à un bon fonctionnement et à la longévité de vos installations</strong>.",
  //       "Nous installons, entretenons et dépannons vos systèmes de <strong>pompe à chaleur (PAC) pour le chauffage et la production d’eau chaude sanitaire</strong>. Une solution économique, écologique et performante pour moderniser votre habitat.",
  //       "Canalisations obstruées ? WC bouchés ? Éviers lents à s’écouler ? Nous disposons de tout l’équipement nécessaire pour <strong>déboucher efficacement vos installations, dans le respect de l’hygiène et de la sécurité</strong>.",
  //     ],
  //   },
  //   {
  //     name: "Chemisage",
  //     icon: zincIco,
  //     offset: "75%",
  //     tags: ["chemisage par spray", "chemisage par gaine"],
  //     def: [
  //       "Le chemisage par <strong>spray</strong> : Notre système de projection de <strong>résine époxy restaure efficacement l'intérieur des canalisations endommagées</strong> en créant un nouveau revêtement protecteur. Cette technique est idéale pour traiter les conduites présentant des <strong>problèmes localisés comme les fissures, perforations ou infiltrations de racines</strong>.",
  //       "Le chemisage par <strong>gaine</strong> : Pour les <strong>dégradations plus étendues</strong>, nous utilisons une méthode de <strong>gainage complet</strong> où un manchon imprégné de résine est inséré puis polymérisé dans la canalisation, <strong>formant ainsi une nouvelle conduite à l'intérieur de l'ancienne</strong>.",
  //     ],
  //   },
  //   {
  //     name: "Dépannage",
  //     icon: repairIco,
  //     offset: "25%",
  //     tags: ["Dépannage et entretien"],
  //     def: [
  //       "Nous intervenons rapidement pour tout type de problème : <strong>fuite, robinetterie défectueuse, chauffe-eau en panne, canalisation bouchée…</strong> Nos techniciens qualifiés assurent également l’entretien régulier de vos installations pour prévenir les pannes et prolonger leur durée de vie.",
  //     ],
  //   },
  //   {
  //     name: "Travaux acrobatiques",
  //     icon: worker,
  //     offset: "35%",
  //     tags: [
  //       "Purge de façades",
  //       "Entretien d’ouvrages d’art et structures spécifiques",
  //       "Systèmes anti-volatiles",
  //       "Nettoyage de surfaces difficiles d’accès",
  //       "Levage et manutention en hauteur",
  //       "Travaux divers en accès difficile",
  //     ],
  //     def: [
  //       "La sécurité des passants et des biens impose un entretien régulier des façades. Nos techniciens réalisent des <strong>purges préventives ou curatives</strong> pour retirer <strong>tout élément instable (morceaux d’enduit, pierres, briques, etc.) menaçant de se détacher</strong>.",
  //       "Clochers, monuments historiques, ponts, charpentes métalliques… certains ouvrages nécessitent une expertise pointue en accès difficile. Nos cordistes assurent <strong>le nettoyage, l’inspection, la maintenance ou la réparation</strong> de ces structures, <strong>dans le respect des normes de sécurité les plus strictes</strong>.",
  //       "Les nuisances causées par les pigeons ou autres oiseaux peuvent détériorer vos façades, <strong>obstruer les gouttières et nuire à l’hygiène</strong>. Nos équipes installent <strong>des dispositifs adaptés à chaque configuration : pics, filets, câbles tendus… sans altérer l’esthétique des bâtiments</strong>.",
  //       "Des vitres d’immeubles aux façades d’entreprise, en passant par les verrières ou les bardages industriels, nous réalisons un <strong>nettoyage en profondeur, en hauteur, sans perturber l’activité du site</strong>. Résultat : un entretien optimal, réalisé dans les <strong>meilleures conditions de sécurité</strong>.",
  //       "Nous assurons le <strong>levage et la mise en place d’équipements techniques</strong> : climatiseurs, unités de traitement d’air, stores, éléments de charpente… Nous concevons chaque manœuvre sur mesure, en fonction du poids, de l’environnement et des contraintes du site.",
  //       `<p>Au-delà des missions classiques, notre équipe peut intervenir pour toute tâche nécessitant un savoir-faire technique combiné à des compétences en déplacement vertical :</p>
  //  <ul>
  //    <li><strong>Remplacement d’éléments techniques en toiture</strong></li>
  //    <li><strong>Contrôle et relevé photographique de structures</strong></li>
  //    <li><strong>Étanchéité ponctuelle</strong></li>
  //    <li><strong>Assistance à d’autres corps de métier</strong></li>
  //  </ul>`,
  //     ],
  //   },
  // ];

  const services = [
    {
      name: "Plomberie",
      icon: plumbingIco,
      offset: "50%",
      tags: [
        "Rénovation",
        "Traitement de l’eau",
        "Recherche de fuites",
        "Curage et pompage",
        "Pompe à chaleur",
        "Dégorgement / débouchage",
      ],
      def: [
        "Nous assurons la rénovation complète de vos projets, de la salle de bain au chantier complet.",
        "Nous proposons des adoucisseurs, systèmes anti-calcaire et filtres spécifiques, en vous conseillant sur les meilleures options selon votre installation et vos besoins.",
        "Nous utilisons des méthodes non destructives (fluorescéine, caméra thermique, testeur d’humidité) pour localiser les fuites sans détériorations.",
        "Nous réalisons le curage haute pression et le pompage, indispensables à un bon fonctionnement et à la longévité de vos installations.",
        "Nous installons et entretenons vos pompes à chaleur et VRV.",
        "Nous débouchons efficacement vos installations dans le respect de l’hygiène et de la sécurité.",
      ],
    },
    {
      name: "Chemisage",
      icon: zincIco,
      offset: "75%",
      tags: ["Chemisage par spray", "Chemisage par gaine", "Passage caméra"],
      def: [
        "Notre chemisage par spray utilise une résine époxy qui restaure efficacement l’intérieur des canalisations endommagées, idéale pour traiter des problèmes localisés comme les fissures, perforations ou infiltrations de racines.",
        "Pour les dégradations plus étendues, nous utilisons une méthode de gainage complet, où un manchon imprégné de résine sera inséré afin de former une nouvelle conduite à l’intérieur de l’ancienne.",
        "Nous réalisons des inspections vidéo, à l’aide d’une caméra endoscopique, et réalisons un rapport complet avec photos et vidéo.",
      ],
    },
    {
      name: "Dépannage",
      icon: repairIco,
      offset: "25%",
      tags: ["Dépannage et entretien"],
      def: [
        "Nous intervenons rapidement en cas de fuite, robinetterie défectueuse, chauffe-eau en panne ou canalisation bouchée, tout en assurant l’entretien régulier de vos installations.",
      ],
    },
    {
      name: "Travaux acrobatiques",
      icon: worker,
      offset: "35%",
      tags: [
        "Purge de façades",
        "Entretien d’ouvrages d’art et structures spécifiques",
        "Systèmes anti-volatiles",
        "Nettoyage de surfaces difficiles d’accès",
        "Levage et manutention en hauteur",
        "Travaux divers en accès difficile",
      ],
      def: [
        "Nous réalisons des purges préventives ou curatives pour retirer tout élément instable (morceaux d’enduit, pierres, briques…) menaçant de se détacher.",
        "Nous assurons le nettoyage, l’inspection, la maintenance ou la réparation de ces structures, dans le respect des normes de sécurité les plus strictes.",
        "Nous empêchons les nuisances qui obstruent les gouttières et nuisent à l’hygiène, en installant des dispositifs adaptés à chaque configuration : pics, filets, câbles tendus, sans altérer l’esthétique des bâtiments.",
        "Nous réalisons un nettoyage en profondeur, en hauteur, sans perturber l’activité du site et dans les meilleures conditions de sécurité.",
        "Nous assurons le levage et la mise en place d’équipements techniques.",
        "Remplacement d’éléments techniques en toiture, contrôle et relevé photographique de structures, étanchéité ponctuelle et assistance à d’autres corps de métier.",
      ],
    },
  ];

  return (
    <section className="Service" id="services">
      <div className="curve">
        <div className="icons">
          {services.map(({ name, icon, tags, offset, def }) => (
            <div
              key={name}
              className="icon"
              style={{ "--offset-distance": offset }}
            >
              <img src={icon} alt={name} />

              <div className="card">
                <h3>{name}</h3>
                <ul>
                  {tags.map((t, i) => (
                    <li key={t} className="tag">
                      {t}
                      <div
                        className="tag-def"
                        dangerouslySetInnerHTML={{ __html: def[i] }}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <article>
        <h2>Nos services</h2>
        {/* <p>
          Chaque employé de notre société NICE PLOMBERIE bénéficie d'une
          formation continue au sein même de notre société.
        </p> */}
      </article>
    </section>
  );
}

// export function ServicePart2() {
//   return (
//     <section className="ServicePart2">
//       <li>
//         <div className="line blue"></div>
//         <article>
//           <h3>LA PLOMBERIE</h3>
//           <p>
//             Installation, entretien et réparation de sanitaires (salles de
//             bains, WC), chauffe-eaux, douches (classiques ou à l’italienne) et
//             baignoires.
//             <div className="br" />
//             Pose des arrivées et évacuations d’eau, raccordements, détection et
//             réparation de fuites, débouchage de canalisations.
//           </p>
//         </article>
//       </li>
//       <li className="second">
//         <div className="line pink"></div>
//         <article>
//           <h3>LE CHAUFFAGE</h3>
//           <p>
//             Un chauffage défectueux nuit à votre confort et peut mettre votre
//             santé en danger, quelle que soit la saison.
//             <div className="br" /> Nos techniciens interviennent rapidement pour
//             l’installation, l’entretien et le dépannage de :
//             <ul>
//               <li className="list">Chauffages individuels et collectifs</li>
//               <li className="list">Radiateurs</li>
//               <li className="list">Chaudières murales ou au sol</li>
//               <li className="list">
//                 Réseaux de canalisations
//                 <div className="br" />
//               </li>
//             </ul>
//             Devis rapideet expertise garantie.
//           </p>
//         </article>
//       </li>
//       <li>
//         <div className="line red"></div>
//         <article>
//           <h3>COUVERTURES &amp; ZINGUERIE</h3>
//           <p>
//             Réalisation de travaux de couverture, en neuf comme en rénovation.
//             <div className="br" />
//             Nos zingueurs qualifiés interviennent sur les toitures
//             traditionnelles et assurent la pose de :
//             <ul>
//               <li className="list">Couvertures en zinc, cuivre ou tuiles</li>
//               <li className="list">Gouttières (zinc, cuivre, PVC)</li>
//               <li className="list">Chéneaux et chiens-assis</li>
//               <div className="br" />
//             </ul>
//             Nous sommes aussi spécialisés dans la restauration de toitures
//             anciennes, y compris sur monuments historiques (dômes, clochers…).
//           </p>
//         </article>
//       </li>
//     </section>
//   );
// }
